import { Button } from '@mui/material'
import { MouseEventHandler } from 'react'
import { buttonStyle } from './style'

type ButtonProps = {
	title?: string,
	textColor?: any,
	backgroundColor?: any,
	onClick?: MouseEventHandler<HTMLButtonElement> | undefined,
	disabled?: boolean,
	type?: any
	sx?:any
}

export default function ContainedButton({ title, textColor, backgroundColor, onClick, disabled = false, type = 'button', sx }: ButtonProps) {

	return <Button 
		fullWidth 
		variant='contained' 
		disabled={disabled}
		type={type}
		sx={{ 
			...buttonStyle, 
			color: textColor, 
			backgroundColor: backgroundColor,
			":hover": {
				color: textColor, 
				backgroundColor: backgroundColor,
			},
			...sx
		}} 
		onClick={disabled ? () => {} : onClick}
	>
		{title}
	</Button>
}
